<template>
  <div>
    <QS-scroller-box>
      <!-- --开始------订单基本信息------------- -->
      <div class="details_content_repeat">
        <QS-h4-title title="订单基本信息" />
        <div class="details_content_repeat_hundred">
          <column-box-expand
            :source="computedOrderData"
            :list="baseInfoList"
            :separator="columnSeparator"
            label-width="150"
          >
          </column-box-expand>
        </div>
      </div>
      <!-- --结束------订单基本信息------------- -->

      <!-- --开始------订单签约信息------------- -->
      <div class="details_content_repeat">
        <QS-h4-title title="订单签约信息" />
        <div class="details_content_repeat_hundred">
          <!-- 线下 -->
          <template v-if="computedOrderData.signType === 0">
            <el-form :model="orderSigningDefault">
              <column-box-expand :column="1">
                <el-form-item
                  required
                  :label="'签署方式' + columnSeparator"
                  class="alone"
                >
                  线下签署租赁合同
                </el-form-item>
                <el-form-item
                  required
                  :label="'合同附件上传' + columnSeparator"
                  class="alone"
                >
                  <UploadCommon
                    :fileList="archiveUrlList"
                    :limit="1"
                    :drag="true"
                    listType="text"
                    :sizeType="4"
                    acceptType=".pdf,.png,.jpg,.jpeg,.webp"
                    commonUpload
                    group="order"
                    code="order_contract_attachment_file"
                  ></UploadCommon>
                </el-form-item>
              </column-box-expand>
            </el-form>
          </template>

          <!-- 线上 -->
          <template v-else>
            <el-form>
              <column-box-expand :column="3">
                <el-form-item
                  required
                  :label="'合同模板' + columnSeparator"
                  class="alone"
                >
                  <el-input
                    v-if="isHaveTemplate || onlineDisabled"
                    style="width: 180px"
                    disabled
                    v-model="templateName"
                  />
                  <el-select
                    v-else
                    v-model="orderSigningDefault.templateId"
                    placeholder="请选择"
                    :clearable="true"
                    :filterable="true"
                    :disabled="isHaveTemplate || onlineDisabled"
                  >
                    <el-option
                      v-for="item in contractList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <el-button
                    :disabled="prewDisabled"
                    @click="getPreview"
                    type="primary"
                  >预览</el-button>
                </el-form-item>
                <el-form-item
                  required
                  :label="'签署方式' + columnSeparator"
                >
                  线上签署（e签宝）
                </el-form-item>
                <el-form-item
                  required
                  :label="'合同编号' + columnSeparator"
                >
                {{ computedOrderData.orderId || '-' }}
                </el-form-item>
                <el-form-item
                  required
                  :label="'e签宝签署流程ID' + columnSeparator"
                >
                  {{
                    computedOrderData.signId || computedOrderData.signId === 0
                      ? computedOrderData.signId
                      : '--'
                  }}
                </el-form-item>
                <el-form-item
                  required
                  :label="'合同签署状态' + columnSeparator"
                >
                  {{
                    computedOrderData.contractStateName
                      ? computedOrderData.contractStateName
                      : ''
                  }}
                </el-form-item>
                <div
                  v-if="onlineBtnTxt"
                  class="alone"
                  style="padding-left: 150px"
                >
                  <el-button
                    @click="openSignConfirm"
                    :disabled="onlineBtnDisabled"
                    type="primary"
                    style="width: 200px"
                  >{{ onlineBtnTxt }}</el-button>
                </div>
                <el-form-item
                  class="alone"
                  required
                  :label="'已签合同附件' + columnSeparator"
                >
                  <div
                    v-if="computedOrderData.computedContractUrl && computedOrderData.contractState !==6"
                    v-down="{
                      url: computedOrderData.computedContractUrl,
                      name: '合同附件',
                    }"
                    class="comm-down-text-color"
                  >
                    {{'合同附件' + computedContractUrlWithoutQueryString }}
                  </div>
                  <div v-else>--</div>
                </el-form-item>
              </column-box-expand>
            </el-form>
          </template>
        </div>
      </div>
      <!-- --结束------订单签约信息------------- -->

      <!--客户信息-->
      <div class="details_content_repeat">
        <QS-h4-title title="客户信息" />
        <div class="details_content_repeat_hundred">
          <column-box-expand
            :source="computedOrderData"
            :list="customerInformation"
            :separator="columnSeparator"
            label-width="150"
          >
          </column-box-expand>
        </div>
      </div>
      <!--客户信息 结束-->

      <!-- 司管信息 -->
      <DriverManager
        v-if="computedOrderData.orderType === 'personal'"
        :dm="computedOrderData.manager"
        mode="edit"
        showSave
        :orderId="computedOrderData.orderId"
      />

      <!--车辆信息-->
      <div class="details_content_repeat">
        <QS-h4-title title="车辆信息" />
        <div class="details_content_repeat_hundred">
          <column-box-expand
            :source="computedOrderData"
            :list="ehicleInformation"
            :separator="columnSeparator"
            label-width="150"
          >
          </column-box-expand>
        </div>
      </div>
      <!--租赁信息-->
      <div class="details_content_repeat">
        <QS-h4-title title="租赁信息" />
        <div class="details_content_repeat_hundred">
          <column-box-expand
            :source="computedOrderData"
            :list="leaseInformation"
            :separator="columnSeparator"
            label-width="150"
          >
          </column-box-expand>
        </div>
        <LadderScheme
          :ladderSchemeList="computedOrderData.piecewiseConfigList || {}"
          :titleList="titleList"
        />
      </div>
      <template slot="bottomAction">
        <el-button
          @click="confirmSubmit(0)"
          v-if="
            computedOrderData.signType === 0 && computedOrderData.state === 0
          "
          :loading="oLoading.submit"
          size="small"
        >保存信息并返回列表</el-button>
        <el-button
          v-else
          @click="goPageBack"
          size="small"
        >返回列表</el-button>
        <el-button
          v-if="computedOrderData.state === 0"
          @click="confirmSubmit(1)"
          :loading="oLoading.submit"
          :disabled="onlineBtnDisabled"
          type="primary"
          size="small"
        >确认订单签署信息</el-button>
      </template>
    </QS-scroller-box>
  </div>
</template>
<script>
import LadderScheme from '@/components/LadderScheme'
import { contractTmpList } from '@/api/company'
import { getSubmitDingTalkShow } from '@/api/global'
import { leaseOrderStartSign, leaseOrderInvalidSign, leaseOrderCancelSign, leaseContractOrderConfirm } from '@/api/purchaseAndSaleAPI'
import DriverManager from '@/components/DriverManager/index.vue'
import { TEMPLATE_STATE_MAP } from '@/store/dict/templateDict.js'
import selectOptionDict from '@/store/dict/selectOptionDict'

export default {
  name: 'OrderConfirm',
  props: {
    computedOrderData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    LadderScheme,
    DriverManager,
  },
  data() {
    return {
      titleList: [
        {
          label: '阶梯',
          value: '',
        },
        {
          label: '起止月数',
          value: 'ladderDate',
        },
        {
          label: '租金(元)',
          value: 'amount',
        },
      ],
      oLoading: {
        submit: false,
      },
      // 租赁合同基本信息左侧key值
      baseInfoList: [
        {
          key: 'id',
          name: '订单ID',
        },
        {
          key: 'stateName',
          name: '订单状态',
        },
        {
          key: 'gmtCreate',
          name: '订单创建时间',
        },
        {
          key: 'confirmTime',
          name: '订单确认时间',
        },
        {
          key: 'outStockTime',
          name: '验车出库时间',
        },
        {
          key: 'returnCarTime',
          name: '退车发起时间',
        },
        {
          key: 'inStockTime',
          name: '验车入库时间',
        },
        {
          key: 'closeTime',
          name: '订单关闭时间',
        },
        {
          key: 'settlementStateName',
          name: '订单结算状态',
        },
        {
          key: 'relatedOrderIdName',
          name: '是否关联订单',
        },
        {
          key: 'rderRelatedReasonName',
          name: '关联原因',
        },
      ],
      contractList: [],
      customerInformation: [
        {
          key: 'customerTypeName',
          name: '客户类型',
        },
        {
          key: 'customerId',
          name: '客户ID',
        },
        {
          key: 'customerName',
          name: '客户名称',
        },
      ],
      ehicleInformation: [
        {
          // 车型ID到时候需要转
          key: 'modelName',
          name: '订单车型',
        },
        {
          key: 'plateNo',
          name: '绑定车辆',
        },
        {
          key: 'carId',
          name: '车辆ID',
        },
        {
          key: 'inventoryStateName',
          name: '车辆库存状态',
        },
      ],
      leaseInformation: [
        {
          key: 'planName',
          name: '方案模板名称',
        },
        {
          key: 'planRecordId',
          name: '上架单ID',
        },
        {
          key: 'signDate',
          name: '合同签署日期',
        },
        {
          key: 'receivablePeriod',
          name: '收款起止日',
        },
        {
          key: 'payDay',
          name: '缴款日',
        },
        {
          key: 'presentDaysName',
          name: '赠送天数',
        },
        {
          key: 'freeCycle',
          name: '免租周期',
        },
        {
          key: 'totalAmount',
          name: '租金总金额',
          finance: true,
        },
        {
          key: 'payModeName',
          name: '租金收款方式',
        },
        {
          key: 'totalDeposit',
          name: '押金总金额',
          finance: true,
        },
        {
          key: 'remarks',
          name: '备注',
        },
        {
          key: 'rentCategory',
          name: '租赁类别',
        },
        {
          key: 'isOpen',
          name: '租赁方案性质',
        },
      ],
      orderSigningDefault: {
        signChannelName: '线下签署合同',
        templateId: '',
      },
      archiveUrlList: [],
      dingTalkShow: false, // 是否开启钉钉审批流
    }
  },
  created() {
    this.judgePermission('driver_customer_list_detail') && this.setCustomPath()
    this.judgePermission('vehicle_list_detail') && this.setCarIdPath()
    // 获取钉钉审批是否开启 bizType: 26 租赁订单线上签约
    getSubmitDingTalkShow({ bizType: 26 }).then((res) => {
      const { code, data } = res
      if (code === 1) {
        this.dingTalkShow = data
      }
    })
  },
  inject: ['orderData', 'getDetails'],
  computed: {
    templateName() {
      return this.computedOrderData.templateName
    },
    // 预览按钮禁用状态
    prewDisabled() {
      return !this.orderSigningDefault.templateId && this.orderSigningDefault.templateId !== 0
    },
    // 根据是否有方案ID
    isHaveTemplate() {
      return Boolean(this.computedOrderData.planId)
    },
    // 线上签约时是否让select选择，根据合同状态进行区分
    onlineDisabled() {
      // 0待发起/1签署中/2签约成功/3签约失败/5已撤回/6已作废/7撤回中/8审批中
      const { CONTRACT_STATE_MAP } = selectOptionDict
      const stateList = [
        CONTRACT_STATE_MAP.QIANSHUZHONG,
        CONTRACT_STATE_MAP.QIANYUECHENGGONG,
        CONTRACT_STATE_MAP.CHEHUIHZONG,
        CONTRACT_STATE_MAP.SHENPIZHONG,
      ]
      return stateList.includes(this.computedOrderData.contractState)
    },
    // 线上签约按钮的文字
    onlineBtnTxt() {
      if (this.computedOrderData.signType === 0) {
        return ''
      } else if (this.computedOrderData.contractState || this.computedOrderData.contractState === 0) { // 合同状态
        let _text = null
        // 0待发起/1签署中/2签约成功/3签约失败/5已撤回/6已作废/7撤回中
        switch (this.computedOrderData.contractState) {
          case 0:
            // 待发起
            _text = '发起线上签署'
            break
          case 1:
            // 签署中
            _text = '撤回签署合同'
            break
          case 2:
            // 签约成功
            _text = '作废已签合同'
            break
          case 3:
            // 签约失败
            _text = '重新发起签署'
            break
          case 5:
            // 已撤回
            _text = '重新发起签署'
            break
          case 6:
            // 已作废
            _text = '重新发起签署'
            break
          case 7:
            // 撤回中
            _text = '再次发起撤回'
            break
          case 8:
            _text = '审批中'
            break
          default:
            _text = ''
            break
        }
        return _text
      } else {
        return '发起线上签署'
      }
    },
    onlineBtnDisabled() {
      // 开启钉钉审批 && 按钮状态为审批中
      return this.dingTalkShow && this.computedOrderData.contractState === 8
    },
    // 发起签约的confirm弹窗类型
    ifDingTalkConfirm() {
      return this.dingTalkShow && ['发起线上签署', '重新发起签署'].includes(this.onlineBtnTxt)
    },
    computedContractUrlWithoutQueryString() {
      const computedContractUrl = this.computedOrderData.computedContractUrl.slice(this.computedOrderData.computedContractUrl.lastIndexOf('.'))
      return computedContractUrl.indexOf('?') > -1 ? computedContractUrl.split('?')[0] : computedContractUrl
    },
  },
  watch: {
    computedOrderData: {
      handler(val) {
        if (val && val.orderId) {
          this.setData()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 设置值
    setData() {
      /*
        以下两种情况只要命中一条，就进行id赋值，其他情况不进行赋值
        1.合同模版选项置灰(不可选)，直接赋值模版id
        2.合同模版选项未禁用(可选)，且合同模版启用，赋值模版id
      */
      if ((this.isHaveTemplate || this.onlineDisabled) ||
        this.computedOrderData.templateState === TEMPLATE_STATE_MAP.QI_YONG) {
        this.orderSigningDefault.templateId = this.computedOrderData.templateId
      }
      if (this.computedOrderData.templateState === TEMPLATE_STATE_MAP.JIN_YONG) {
        if ((this.isHaveTemplate || this.onlineDisabled)) {
          this.orderSigningDefault.templateId = this.computedOrderData.templateId
        } else {
          this.orderSigningDefault.templateId = ''
        }
      }
      this.archiveUrlList = this.computedOrderData.contractUrl
      // 1-后台下的单 2-商城单  历史单的source字段为空，商城需求上线后的单都带source
      // 商城单使用的合同模版为集团创建的，无需请求合同模版list
      const source = this.computedOrderData?.source
      if (!source || Number(source) === 1) {
        // 获取租赁合同模版list
        this.getContractTmpList(source)
      } else if (Number(source) === 2) {
        this.contractList = [
          {
            name: this.computedOrderData.templateName,
            id: this.computedOrderData.templateId,
          },
        ]
      }
    },
    // 表单提交事件
    contractSubmitHandle() {
      // 0待发起/1签署中/2签约成功/3签约失败/5已撤回/6已作废/7撤回中
      const startState = [null, undefined, 0, 3, 5, 6]
      const revokeState = [1, 7]
      const voidState = [2]

      this.oLoading.submit = true

      // 执行签署操作
      if (startState.includes(this.computedOrderData.contractState)) {
        this.startHandle()
      }
      // 执行撤回操作
      if (revokeState.includes(this.computedOrderData.contractState)) {
        this.revokeHandle()
      }
      // 执行作废操作
      if (voidState.includes(this.computedOrderData.contractState)) {
        this.voidHandle()
      }
    },
    // 签署操作
    startHandle() {
      leaseOrderStartSign({
        orderId: this.computedOrderData.orderId,
        templateId: this.orderSigningDefault.templateId,
      }).then(({ code }) => {
        if (code === 1) {
          this.$message.success('操作成功')
          this.getDetails()
        }
      }).catch((err) => {
        if (err.code === 22029) {
          this.$message.error(err.msg)
          // 选项非禁用，则置空合同模版表单
          if (!(this.isHaveTemplate || this.onlineDisabled)) {
            this.orderSigningDefault.templateId = ''
          }
          this.getContractTmpList()
          this.$message.error(err.msg)
        }
      }).finally(() => {
        this.oLoading.submit = false
      })
    },
    // 撤回操作
    revokeHandle() {
      leaseOrderCancelSign({
        id: this.computedOrderData.contractId,
      }).then(({ code }) => {
        if (code === 1) {
          this.$message.success('操作成功')
          this.getDetails()
        }
      }).finally(() => {
        this.oLoading.submit = false
      })
    },
    // 作废操作
    voidHandle() {
      leaseOrderInvalidSign({
        id: this.computedOrderData.contractId,
      }).then(({ code }) => {
        if (code === 1) {
          this.$message.success('操作成功')
          this.getDetails()
        }
      }).finally(() => {
        this.oLoading.submit = false
      })
    },
    // 获取合同模板列表
    async getContractTmpList() {
      const params = {
        state: 1,
      }
      const { code, data } = await contractTmpList(params)
      if (code === 1) {
        this.contractList = data?.items || []
      }
    },
    // 合同预览
    getPreview() {
      const id = this.orderSigningDefault.templateId
      if (id || id === 0) {
        window.open(
          `/preview?orderId=${this.computedOrderData.orderId}&templateId=${this.orderSigningDefault.templateId}`,
          '_blank',
        )
      } else {
        this.$message.error('请您先选择合同模板，再进行预览操作')
      }
    },
    // 弹窗确认事件
    openSignConfirm() {
      if (!this.orderSigningDefault.templateId) {
        this.$message.error('请选择合同模板')
        return
      }
      const title = this.ifDingTalkConfirm ? '租赁订单线上签约审批' : '提示'
      const content = this.ifDingTalkConfirm ? '发起线上签署合同前，需要进行审批。审批通过系统将立即向签约客户发送短信通知，请注意通知客户查收短信并点击链接完成线上合同签署。' : `您确定${this.onlineBtnTxt}?`
      const confirmButtonText = this.ifDingTalkConfirm ? '提交审批' : '确定'
      this.$confirm(content, title, { confirmButtonText, cancelButtonText: '取消' }).then(() => {
        this.contractSubmitHandle()
      }).catch(() => null)
    },
    // 确认订单操作
    confirmSubmit(type) {
      let templateId = ''
      let archiveUrl = ''

      const postParams = {
        orderId: this.computedOrderData.orderId,
        confirmFlag: type, // 0保存 1确认
      }
      // 线下
      if (this.computedOrderData.signType === 0) {
        if (this.archiveUrlList.length) {
          archiveUrl = this.getUoloadCommonFileData(this.archiveUrlList)
          postParams.archiveUrl = archiveUrl
        } else if (type === 1) {
          this.$message.error('请上传合同附件')
          return
        }
      } else { // 线上
        templateId = this.orderSigningDefault.templateId
        if (this.orderSigningDefault.templateId || this.orderSigningDefault.templateId === 0) {
          postParams.templateId = templateId
        } else {
          this.$message.error('请选择合同模板')
          return
        }
      }
      this.oLoading.submit = true
      leaseContractOrderConfirm(postParams)
        .then(({ code }) => {
          if (code === 1) {
            this.$message.success('操作成功')
            this.goPageBack()
          }
        }).catch((err) => {
          if (err.code === 22029) {
            this.$message.error(err.msg)
            // 选项非禁用，则置空合同模版表单
            if (!(this.isHaveTemplate || this.onlineDisabled)) {
              this.orderSigningDefault.templateId = ''
            }
            this.getContractTmpList()
            this.$message.error(err.msg)
          }
        }).finally(() => {
          this.oLoading.submit = false
        })
    },
    // 返回列表页面
    goPageBack() {
      this.$router.push({
        path: '/workbench/rentOrder/list',
      })
    },
    setCustomPath() {
      const path = {
        path: '/driver/customerManage/detail',
        name: 'driver_customer_list_detail',
        query: {
          id: this.computedOrderData.customerId,
          customerType: this.computedOrderData.customerType,
        },
      }
      this.$set(this.customerInformation[1], 'goPage', path)
    },
    // 设置车辆ID跳转路径
    setCarIdPath() {
      const path = {
        path: '/vehicle/vehicleManage/detail',
        name: 'vehicle_list_detail',
        query: {
          id: this.computedOrderData.carId,
        },
      }
      this.$set(this.ehicleInformation[2], 'goPage', path)
    },
  },
}
</script>
